import {Tr} from "@/i18n/i18n";
import {HorizontalStandardPanel} from "@/scenes.ui/horizontal-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Badge} from "@/store/profile/types";
import {SquareButton} from "@/scenes.ui/square-button";
import {Keys} from "@/constants/key";
import SoundUtils from "@/utils/sound-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class BadgeDetailPanel extends HorizontalStandardPanel {

    private readonly DEPTH: number = 3000;

    constructor(scene: Scene, canvas: HTMLCanvasElement, badge: Badge) {
        super(scene, canvas, Tr('nagrada'));

        this.setDepth(this.DEPTH);

        const clickSound = SoundUtils.addSound(scene, Keys.SOUND_SELECT);

        let icon = SpriteUtils.addSprite(this.scene, 0, -110, Keys.ATLAS_BADGES, badge.rewardId);
        SpriteUtils.setDispSize(icon, 90 * CU.S, 90 * CU.S);

        let infoText = TextUtils.addTextByFamily(scene, badge.name,
            0, icon.y / CU.S + 75, '#ffd465', 18, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        let description = TextUtils.addTextByFamily(scene, badge.description,
            0, icon.y / CU.S + 155, '#716f6a', 17, 'normal', 450, Fonts.ARIAL_MT);

        let okButton = new SquareButton(this.scene, 0, 155, 0, Keys.UI_ART_GREEN_BUTTON,
            Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('horosho'), false, 0, 0, 46);


        okButton.setCallback(() => {
            if (this.isOnTop()) {
                SoundUtils.play(clickSound);
                this.close();
            }
        });

        this.add([icon, infoText, description, okButton]);
    }
}
